import React, { Component } from 'react';
import { ContentCard } from '../Cards';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import EmployeeDependentSpouseSchema from './EmployeeDependentSpouseSchema';
import {
    fetchAddEmployeeDependent,
    fetchEmployee
} from '../../actions/EmployeeActions';
import { userService } from '../../utils/UserService';
import { validateDates } from '../../utils/FormHelper';
import { Form } from '../../utils/FormTemplates';
import EmployeeDependentUISchema from './EmployeeDependentUISchema';
import {  validateSocialSecurity } from '../../validators/rjsf';

class EmployeeDependentSpouseAdd extends Component {
    state = {
        employeeId: null,
        groupId: null,
        formData: null
    };

    componentDidMount() {
        userService
            .currentPersonId()
            .then(personId => {
                if (this.props.packageId) {
                    this.props.fetchEmployee(personId, this.props.packageId).then(employee => {
                        if (employee && employee.personId === parseInt(personId, 10)) {
                            this.setState({
                                employeeId: employee.personId,
                                groupId: employee.groupId
                            });
                        }
                    });
                }
            });
    }

    onCancel = e => {
        this.props.history.goBack();
    };

    validate = (formData, errors) => {
        validateSocialSecurity(formData, errors, (o) => o.usSocialSecurityNumber);
        return errors;
    };

    onAddEmployeeDependent = e => {
        if (validateDates([
            "dateOfBirth",
            "effectiveDate",
            "dateOfDeath",
            "previousSmokerQuitDate",
            "terminateDate"],
            e.formData,
            e.schema
        )) {
            this.props.addEmployeeDependent(e.formData, this.state.employeeId, this.state.groupId)
                .then(() => {
                    this.props.history.goBack();
                });
        }
    };

    onFormChange = e => {
        console.log('test');
        if (e && e.formData && this.state.formData) {
            if (e.formData.isPreviousSmoker !== this.state.formData.isPreviousSmoker || e.formData.isCurrentSmoker !== this.state.formData.isCurrentSmoker) {
                //have to set state twice due to react bug
                //https://github.com/mozilla-services/react-jsonschema-form/issues/517
                this.setState({ formData: null });
                this.setState({ formData: e.formData });
            }
        }
        else if (e && e.formData) {
            this.setState({ formData: null });
            this.setState({ formData: e.formData });
        }
    };

    render() {
        let schema = EmployeeDependentSpouseSchema;
        schema.title = 'Add Dependent';

        let uiSchema = EmployeeDependentUISchema;

        uiSchema.terminateDate = {
            "ui:widget": "hidden",
            "ui:label": false
        };

        let formData = this.state.formData;
        if (formData) {
            if (formData.isCurrentSmoker === true) {
                //disable fields
                uiSchema.isPreviousSmoker = {
                    "ui:widget": "radio",
                    "ui:disabled": true
                };
                uiSchema.previousSmokerQuitDate = {
                    "ui:disabled": true
                };

                //erase field values from disabled fields
                formData.isPreviousSmoker = null;
                formData.previousSmokerQuitDate = null;

                //remove isPreviousSmoker and previousSmokerQuitDate from required fields
                let filtered = schema.required.filter(function (value, index, arr) {
                    return value !== 'isPreviousSmoker' && value !== 'previousSmokerQuitDate';
                });
                schema.required = filtered;
            }
            else if (formData.isCurrentSmoker === false) {
                //enable fields
                uiSchema.isPreviousSmoker = {
                    "ui:widget": "radio",
                    "ui:disabled": false
                };
                uiSchema.previousSmokerQuitDate = {
                    "ui:widget": "customDate",
                    "ui:disabled": false
                };

                //add isPreviousSmoker to required fields
                schema.required = schema.required.concat('isPreviousSmoker');
            }
            if (formData.isPreviousSmoker === false) {
                //disable previousSMokerQuitDate
                uiSchema.previousSmokerQuitDate = {
                    "ui:disabled": true
                };

                //remove previousSmokerQuitDate from required fields
                let filtered = schema.required.filter(function (value, index, arr) {
                    return value !== 'previousSmokerQuitDate';
                });
                schema.required = filtered;
            }
            else if (formData.isPreviousSmoker === true) {
                //enable previousSmokerQuitDate
                uiSchema.previousSmokerQuitDate = {
                    "ui:widget": "customDate",
                    "ui:disabled": false
                };

                //add previousSmokerQuitDate to required fields
                schema.required = schema.required.concat('previousSmokerQuitDate');
            }
        }

        return (
            <ContentCard>
                <Form
                    formData={formData}
                    schema={schema}
                    uiSchema={uiSchema}
                    onSubmit={e => this.onAddEmployeeDependent(e)}
                    onChange={e => this.onFormChange(e)}
                    validate={this.validate}
                >
                    <div className="float-right">
                        <button type="button" className="btn btn-default mr-2" onClick={e => this.onCancel(e)}>Cancel</button>
                        <button type="submit" className="btn btn-primary">Submit</button>
                    </div>
                </Form>
            </ContentCard>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        addedEmployeeDependent: state.employeeDependents.addedEmployeeDependent
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addEmployeeDependent: (dependent, employeeId, groupId) => {
            return dispatch(fetchAddEmployeeDependent(dependent, employeeId, groupId));
        },
        fetchEmployee: (employeeId, packageId) => {
            return dispatch(fetchEmployee(employeeId, packageId));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EmployeeDependentSpouseAdd));